import { apiGet, apiPost, generateFormData } from '../../../modules/apiHelper';
import resolve from '../../../modules/api/resolve';

export default {
  async getEmentoredProgramTypes() {
    const response = await resolve(apiGet('license_list', 92, {}, true));

    if (!response) {
      console.error('error::programs::getProgramTypes');
      return [];
    }

    return response.license_list;
  },

  async listEmentoredPrograms() {
    const [active, deactivated] = await Promise.all([
      resolve(apiGet('ema_prog_list', 92, {}, true)),
      resolve(apiGet('dev_ema_prog_list', 92, {}, true)),
    ]);

    if (!active || !deactivated) return false;

    return {
      active: active.ema_prog_list,
      deactivated: deactivated.dev_ema_prog_list,
    };
  },

  async getEmentoredProgram(context, programId) {
    const formData = generateFormData({
      progid: programId,
    });
    const response = await resolve(apiPost('ema_prog_list_dt', formData, 92));

    if (!response) return false;

    return response.ema_prog_list_dt[0];
  },

  async createEmentoredProgram(context, data) {
    const formData = generateFormData(data);
    formData.set('adminid', context.rootState.User.id);

    const response = await resolve(apiPost('create_ema_prog', formData, 92));

    if (!response) return false;

    return response;
  },

  async activateEmentoredProgram(context, programId) {
    const response = await resolve(apiPost('act_ema_prog', generateFormData({
      progid: programId,
    }), 92));

    return response;
  },

  async deactivateEmentoredProgram(context, programId) {
    const response = await resolve(apiPost('dev_ema_prog', generateFormData({
      progid: programId,
    }), 92));

    return response;
  },

  async updateEmentoredProgram(context, data) {
    const formData = generateFormData(data);
    formData.set('progid', data.programId);
    formData.set('desc', data.description);

    const response = await Promise.all([
      resolve(apiPost('edit_ema_prog_name', formData, 92)),
      resolve(apiPost('edit_ema_prog_desc', formData, 92)),
      resolve(apiPost('edit_ema_prog_type', formData, 92)),
      resolve(apiPost('edit_ema_cost', formData, 92)),
      resolve(apiPost('edit_ema_discount', formData, 92)), // If discount is enabled
      resolve(apiPost('edit_ema_discount_amount', formData, 92)),
    ]);

    return response.every(Boolean);
  },
};
